import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  createUrlTreeFromSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { defaultIfEmpty, filter, map, take } from 'rxjs';
import { selectCheckoutStep } from '../store';

export function stepGuard(step: string, redirectRoute: string): CanActivateFn {
  return (snapshot: ActivatedRouteSnapshot) => {
    const store = inject(Store);

    const currentStep$ = store.select(selectCheckoutStep);

    return currentStep$.pipe(
      take(1),
      filter((s) => s !== null),
      defaultIfEmpty(redirectRoute),
      map((storeCurrentStep) => {
        const match = storeCurrentStep.toLowerCase() === step.toLowerCase();
        return (
          match || createUrlTreeFromSnapshot(snapshot, [`../` + redirectRoute])
        );
      }),
    );
  };
}
